<template>
    <div id="cal">
        <div id="top">
            <div class="select">
                <select id="year-select"></select>&nbsp;年
                <select id="month-select"></select>&nbsp;月
            </div>
            <div class="step">
                <span id="prev">&lt;</span>
                <span id="next">&gt;</span>                               
            </div>
        </div>
        <ul id="wk">
            <li>一</li>
            <li>二</li>
            <li>三</li>
            <li>四</li>
            <li>五</li>
            <li><b>六</b></li>
            <li><b>日</b></li>
        </ul>
        <div id="cm"></div>
        <div id="bm">
            <div class="heavenly-branch">
                <span id="heavenly"></span>年 &nbsp;
                ［<span id="branch"></span>］
            </div>
            <a href="javascript:;" id="now-date">回到今天</a>
        </div>
    </div>
</template>

<script>
    import 'assets/js/calendar.js'
    
    export default {
        name: 'CCalendar',
        data() {
            return {}
        },
        mounted() {
            calendar.init({
                cellClickCallback: function(cell, datedata){
                    console.log('你点击的是'+ datedata.solarYear + '年' + datedata.solarMonth + '月' + datedata.solarDate + '日');    
                }
            });
        }
    }
</script>

<style>
#cal {font-size: 12px;}
#cal #top {height: 30px;line-height: 30px;background: #8E8E8E;border: 1px solid #8E8E8E;color: #fff;padding: 0 2px;clear: both;}
#cal #top select {font-size: 12px}
#cal #top input {padding: 0}
#cal ul#wk {margin: 0;padding: 0 0 5px 0; height: 25px;color: #888;font-size: 12px; border-left: 1px solid #8E8E8E;border-right: 1px solid #8E8E8E;}
#cal ul#wk li {float: left;width: 32px;text-align: center;line-height: 25px;list-style: none}
#cal ul#wk li b {font-weight: normal;color: #8E8E8E;}
#cal #cm {position: relative;border-left: 1px solid #8E8E8E;border-right: 1px solid #8E8E8E;}
#cal #cm .cell {position: absolute;width: 12px;height: 12px;text-align: center;margin:0 10px;cursor: pointer;}
#cal #cm .cell div.so {font: 12px arial;}
#cal #bm {text-align: right;height: 30px;line-height: 30px;padding: 0 3px 0 0;border: 1px solid #8E8E8E;border-top: 1px dashed #eee;clear: both;font-size: 12px;}
#cal #bm .heavenly-branch {color: #8E8E8E;float: left; margin-left: 8px;}
#cal #fd {display: none;position: absolute;border: 1px solid #dddddf;background: #fff;color: #333;padding: 10px;line-height: 21px;width: 150px;border-radius: 10px;}
#cal #fd:before{content: '';position: absolute;left: -8px;width: 0;height: 0;border-top: 8px solid transparent;border-right: 8px solid #dddddf;border-bottom: 8px solid transparent;}
#cal #fd:after{content: ''; position: absolute;left: -6px;top: 10px;width: 0;height: 0;border-top: 8px solid transparent;border-right: 8px solid #fff;border-bottom: 8px solid transparent;}
#cal #fd b {font-weight: normal;color: #8E8E8E;}
#cal .step {float: right;font-size: 16px;}
#cal .step span{cursor: pointer;}
#cal .step #prev{margin-right: 10px;}
#cal .select{float: left;}
#cal .select select{-webkit-appearance: none;padding: 5px;}
#cal #now-date{float: right;padding: 0px 10px;background-color: #8E8E8E;color: #fff;font-size: 12px;height: 20px;line-height: 20px;margin-top: 6px;text-decoration: none;}    
</style>